// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-23cfd7eb] {\n  width: 90px;\n}\n.invoice-filter-select[data-v-23cfd7eb] {\n  min-width: 190px;\n}\n.invoice-filter-select[data-v-23cfd7eb]  .vs__selected-options {\n  flex-wrap: nowrap;\n}\n.invoice-filter-select[data-v-23cfd7eb]  .vs__selected {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
